import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Noise } from "@/components/Noise";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { CookieConsent } from "@/components/CookieConsent";
import { WhatsAppFab } from "@/components/Social";
import Privacy from "@/pages/legal/Privacy";
import Cookies from "@/pages/legal/Cookies";
import LegalNotice from "@/pages/legal/LegalNotice";
import Terms from "@/pages/legal/Terms";
import Accessibility from "@/pages/legal/Accessibility";
import Team from "@/pages/Team";
import OrgChart from "@/pages/OrgChart";
import InstallApp from "@/pages/InstallApp";

function AppRoutes() {
  const location = useLocation();
  // Handle Google OAuth return BEFORE any protected route runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/acceso" element={<Auth />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/privacidad" element={<Privacy />} />
      <Route path="/cookies" element={<Cookies />} />
      <Route path="/aviso-legal" element={<LegalNotice />} />
      <Route path="/terminos" element={<Terms />} />
      <Route path="/accesibilidad" element={<Accessibility />} />
      <Route path="/equipo" element={<Team />} />
      <Route path="/organigrama" element={<OrgChart />} />
      <Route path="/instalar" element={<InstallApp />} />
      <Route
        path="/panel"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  useLenis();
  return (
    <div className="App relative bg-[#05070f] text-white">
      <div className="bg-aura" aria-hidden="true" />
      <Noise />
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <CookieConsent />
          <WhatsAppFab />
        </BrowserRouter>
      </AuthProvider>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#101014",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
